import React from "react"
import WeatherCountry from "./WeatherCountry"

const ListCountries = ({countriesList,handleButton}) => {
    return(
        <>
            {
                countriesList.length > 1 ?
                countriesList.map(country => {
                    return (
                        <li key={country.name.id}>
                            {country.name.common}
                            <button 
                                value={country.name.common}
                                onClick={handleButton}>
                                show
                            </button>
                        </li>
                    )
                }):
                countriesList.map(country => {
                    return (
                        <section className="main-country__info">
                            <h2>{country.name.common}</h2>
                            {
                                country.capital ? 
                                country.capital.length > 1 ?
                                    <>
                                        <p><strong>Capital:</strong></p>
                                        <ul>
                                            {
                                                country.capital.map(capital => {
                                                    return <li>{capital}</li>
                                                })
                                            }
                                        </ul>
                                    </> :
                                    <p><strong>Capital:</strong> {country.capital}</p> :
                                    <>
                                        <p><strong>Capital:</strong> No specified</p>
                                    </>
                            }
                            <p><strong>Population:</strong> {country.population}</p>
                            <WeatherCountry 
                                country_name={country.name.common}/>
                            <article className="main-country__languages">
                                <p><strong>Languages</strong></p>
                                <ul>
                                    {
                                        country.languages ?
                                        Object.values(country.languages).map(language => <li>{language}</li>) :
                                        <li>No specified</li>
                                    }
                                </ul>
                            </article>
                            <span className="main-flag">{country.flag}</span>
                        </section>
                    )
                })
            }
        </>
    )
}

export default ListCountries